/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceScheduleTemplateItem } from "./DeviceScheduleTemplateItem";
import {
    DeviceScheduleTemplateItemFromJSON,
    DeviceScheduleTemplateItemFromJSONTyped,
    DeviceScheduleTemplateItemToJSON,
} from "./DeviceScheduleTemplateItem";

/**
 *
 * @export
 * @interface DeviceScheduleTemplateDto
 */
export interface DeviceScheduleTemplateDto {
    /**
     *
     * @type {number}
     * @memberof DeviceScheduleTemplateDto
     */
    deviceScheduleTemplateId?: number;
    /**
     * Currently only Recurring templates are supported
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    scheduleType?: DeviceScheduleTemplateDtoScheduleTypeEnum;
    /**
     * Active: show to enterprise and end usersInactive: show to enterprise onlyDeleted: not shown
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    status?: DeviceScheduleTemplateDtoStatusEnum;
    /**
     * Used to determine if a template may be applied to a charger:True: schedule items are for solar aware chargers only.False: schedule items are for non-solar aware chargers only.Null: don't care (both).Once a Template is created, this value is read-only.
     * @type {boolean}
     * @memberof DeviceScheduleTemplateDto
     */
    solarAware?: boolean;
    /**
     * True if the template's schedules should cover an entire period (entire day or week). False if there are gaps. Once a Template is created, this value is read-only.
     * @type {boolean}
     * @memberof DeviceScheduleTemplateDto
     */
    gapless?: boolean;
    /**
     * The time zone the template is for, eg 'Australia/Melbourne', 'UTC+10' (NEM time).Certain retailers still define peak/off-peak rates in the NEM timezone, which is UTC+10 everywhere. In this case, explicitly set the timezone on the template.If instead, the retailer defines their times based on the customer's location, then leave it null and the user's local time zone will be used when applying this template.
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    timeZone?: string;
    /**
     * Optional user facing name, eg 'MyRetailer SimplePlan Off-Peak'
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    description?: string;
    /**
     * Templates are ordered by Organisation.RowSequence,DeviceScheduleTemplate.RowSequence asc.
     * @type {number}
     * @memberof DeviceScheduleTemplateDto
     */
    rowSequence?: number;
    /**
     * Template org, required when creating (unless creating global template)
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    organisationId?: string;
    /**
     * Read-only org name
     * @type {string}
     * @memberof DeviceScheduleTemplateDto
     */
    organisationName?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceScheduleTemplateDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceScheduleTemplateDto
     */
    updatedAt?: Date;
    /**
     * Currently only Recurring templates are supported
     * @type {Array<DeviceScheduleTemplateItem>}
     * @memberof DeviceScheduleTemplateDto
     */
    schedules?: Array<DeviceScheduleTemplateItem>;
}

/**
 * @export
 */
export const DeviceScheduleTemplateDtoScheduleTypeEnum = {
    Default: "Default",
    OneShot: "OneShot",
    Recurring: "Recurring",
    DeviceManaged: "DeviceManaged",
} as const;
export type DeviceScheduleTemplateDtoScheduleTypeEnum =
    (typeof DeviceScheduleTemplateDtoScheduleTypeEnum)[keyof typeof DeviceScheduleTemplateDtoScheduleTypeEnum];

/**
 * @export
 */
export const DeviceScheduleTemplateDtoStatusEnum = {
    Unknown: "Unknown",
    Active: "Active",
    Inactive: "Inactive",
    Deleted: "Deleted",
} as const;
export type DeviceScheduleTemplateDtoStatusEnum =
    (typeof DeviceScheduleTemplateDtoStatusEnum)[keyof typeof DeviceScheduleTemplateDtoStatusEnum];

/**
 * Check if a given object implements the DeviceScheduleTemplateDto interface.
 */
export function instanceOfDeviceScheduleTemplateDto(
    value: object,
): value is DeviceScheduleTemplateDto {
    return true;
}

export function DeviceScheduleTemplateDtoFromJSON(
    json: any,
): DeviceScheduleTemplateDto {
    return DeviceScheduleTemplateDtoFromJSONTyped(json, false);
}

export function DeviceScheduleTemplateDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceScheduleTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        deviceScheduleTemplateId:
            json["deviceScheduleTemplateId"] == null
                ? undefined
                : json["deviceScheduleTemplateId"],
        scheduleType:
            json["scheduleType"] == null ? undefined : json["scheduleType"],
        status: json["status"] == null ? undefined : json["status"],
        solarAware: json["solarAware"] == null ? undefined : json["solarAware"],
        gapless: json["gapless"] == null ? undefined : json["gapless"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        description:
            json["description"] == null ? undefined : json["description"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        organisationName:
            json["organisationName"] == null
                ? undefined
                : json["organisationName"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        schedules:
            json["schedules"] == null
                ? undefined
                : (json["schedules"] as Array<any>).map(
                      DeviceScheduleTemplateItemFromJSON,
                  ),
    };
}

export function DeviceScheduleTemplateDtoToJSON(
    value?: DeviceScheduleTemplateDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceScheduleTemplateId: value["deviceScheduleTemplateId"],
        scheduleType: value["scheduleType"],
        status: value["status"],
        solarAware: value["solarAware"],
        gapless: value["gapless"],
        timeZone: value["timeZone"],
        description: value["description"],
        rowSequence: value["rowSequence"],
        organisationId: value["organisationId"],
        organisationName: value["organisationName"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        schedules:
            value["schedules"] == null
                ? undefined
                : (value["schedules"] as Array<any>).map(
                      DeviceScheduleTemplateItemToJSON,
                  ),
    };
}
